import {TypedMutationOnQueryStarted} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';

import {invalidateOnSuccess, metadaApi, metadaBaseQuery} from '@dms/api/base';

import {
  CheckoutIdArgSchema,
  CheckoutIdPaymentIdArgSchema,
  DeleteCheckoutAdditionalCustomerApiArg,
  DeleteCheckoutAdditionalCustomerApiArgSchema,
  DeleteCheckoutAdditionalCustomerApiResponse,
  DeleteCheckoutAdditionalCustomerApiResponseSchema,
  DeleteCheckoutDepositPaymentApiArg,
  DeleteCheckoutDepositPaymentApiResponse,
  DeleteCheckoutDepositPaymentApiResponseSchema,
  GetCheckoutAllowedCustomerApiArg,
  GetCheckoutAllowedCustomerApiResponse,
  GetCheckoutAllowedCustomerApiResponseSchema,
  GetCheckoutBillingInformationApiArg,
  GetCheckoutBillingInformationApiResponse,
  GetCheckoutBillingInformationApiResponseSchema,
  GetCheckoutByIdApiArg,
  GetCheckoutByIdApiResponse,
  GetCheckoutByIdApiResponseSchema,
  GetCheckoutLinkForServiceOrderApiArg,
  GetCheckoutLinkForServiceOrderApiArgSchema,
  GetCheckoutLinkForServiceOrderApiResponse,
  GetCheckoutLinkForServiceOrderApiResponseSchema,
  GetCheckoutPaymentByIdApiArg,
  GetCheckoutPaymentByIdApiResponse,
  GetCheckoutPaymentByIdApiResponseSchema,
  GetCheckoutPaymentIssueRestrictionApiArg,
  GetCheckoutPaymentIssueRestrictionApiResponse,
  GetCheckoutPaymentIssueRestrictionApiResponseSchema,
  GetCheckoutPaymentsV2ApiArg,
  GetCheckoutPaymentsV2ApiResponse,
  GetCheckoutPaymentsV2ApiResponseSchema,
  GetCheckoutPaymentTransactionsApiArgSchema,
  GetCheckoutPaymentTransactionsApiResponseSchema,
  GetCheckoutPaymentTransactionsApiArg,
  GetCheckoutPaymentTransactionsApiResponse,
  PatchCheckoutAdditionalCustomerApiArg,
  PatchCheckoutAdditionalCustomerApiArgSchema,
  PatchCheckoutAdditionalCustomerApiResponse,
  PatchCheckoutAdditionalCustomerApiResponseSchema,
  PatchCheckoutForeignCurrencyPaymentDisallowApiArg,
  PatchCheckoutForeignCurrencyPaymentDisallowApiResponse,
  PatchCheckoutForeignCurrencyPaymentDisallowApiResponseSchema,
  PatchCheckoutPaymentApiArg,
  PatchCheckoutPaymentApiArgSchema,
  PatchCheckoutPaymentApiResponse,
  PatchCheckoutPaymentApiResponseSchema,
  PostCheckoutAdditionalCustomerApiArg,
  PostCheckoutAdditionalCustomerApiArgSchema,
  PostCheckoutAdditionalCustomerApiResponse,
  PostCheckoutAdditionalCustomerApiResponseSchema,
  PostCheckoutAllowAbroadSaleApiArg,
  PostCheckoutAllowAbroadSaleApiArgSchema,
  PostCheckoutAllowAbroadSaleApiResponse,
  PostCheckoutAllowAbroadSaleApiResponseSchema,
  PostCheckoutDepositPaymentCreateApiArg,
  PostCheckoutDepositPaymentCreateApiResponse,
  PostCheckoutDepositPaymentCreateApiResponseSchema,
  PostCheckoutDisallowAbroadSaleApiArg,
  PostCheckoutDisallowAbroadSaleApiArgSchema,
  PostCheckoutDisallowAbroadSaleApiResponse,
  PostCheckoutDisallowAbroadSaleApiResponseSchema,
  PostCheckoutForeignCurrencyPaymentAllowApiArg,
  PostCheckoutForeignCurrencyPaymentAllowApiArgSchema,
  PostCheckoutForeignCurrencyPaymentAllowApiResponse,
  PostCheckoutForeignCurrencyPaymentAllowApiResponseSchema,
  PostCheckoutPaymentIssueApiResponseSchema,
  PostCheckoutRecordPaidApiArg,
  PostCheckoutRecordPaidApiArgSchema,
  PostCheckoutRecordPaidApiResponse,
  PostCheckoutRecordPaidApiResponseSchema,
  PutCheckoutDepositPaymentAllowApiArg,
  PutCheckoutDepositPaymentAllowApiArgSchema,
  PutCheckoutDepositPaymentAllowApiResponse,
  PutCheckoutDepositPaymentAllowApiResponseSchema,
  PutCheckoutDepositPaymentDisallowApiArg,
  PutCheckoutDepositPaymentDisallowApiArgSchema,
  PutCheckoutDepositPaymentDisallowApiResponse,
  PutCheckoutDepositPaymentDisallowApiResponseSchema,
  PutCheckoutSetBillingInformationApiArg,
  PutCheckoutSetBillingInformationApiArgSchema,
  PutCheckoutSetBillingInformationApiResponse,
  PutCheckoutSetBillingInformationApiResponseSchema,
  PutCheckoutSetContractInformationApiArg,
  PutCheckoutSetContractInformationApiArgSchema,
  PutCheckoutSetContractInformationApiResponse,
  PutCheckoutSetContractInformationApiResponseSchema,
  PutCheckoutSetTypeOfSaleApiArg,
  PutCheckoutSetTypeOfSaleApiArgSchema,
  PutCheckoutSetTypeOfSaleApiResponse,
  PutCheckoutSetTypeOfSaleApiResponseSchema,
  PostCheckoutPaymentTransactionCancelApiArgSchema,
  PostCheckoutPaymentTransactionCancelApiResponseSchema,
  PostCheckoutPaymentTransactionCancelApiArg,
  PostCheckoutPaymentTransactionCancelApiResponse,
  PostCheckoutPaymentTransactionIssueTaxDocumentApiArgSchema,
  PostCheckoutPaymentTransactionIssueTaxDocumentApiResponseSchema,
  PostCheckoutPaymentTransactionIssueTaxDocumentApiArg,
  PostCheckoutPaymentTransactionIssueTaxDocumentApiResponse,
  PostCheckoutPayBankTransferApiArg,
  PostCheckoutPayBankTransferApiResponse,
  PostCheckoutPayBankTransferApiResponseSchema,
  PostCheckoutPayBankTransferApiArgSchema,
  PostCheckoutPayCardApiArgSchema,
  PostCheckoutPayCardApiResponseSchema,
  PostCheckoutPayCardApiArg,
  PostCheckoutPayCardApiResponse,
  PostCheckoutPayCardReceiptApiArgSchema,
  PostCheckoutPayCardReceiptApiResponseSchema,
  PostCheckoutPayCardReceiptApiArg,
  PostCheckoutPayCardReceiptApiResponse,
  PostCheckoutPayCashApiArgSchema,
  PostCheckoutPayCashApiResponseSchema,
  PostCheckoutPayCashApiArg,
  PostCheckoutPayCashApiResponse,
  PostCheckoutPayCashReceiptApiResponseSchema,
  PostCheckoutPayCashReceiptApiArg,
  PostCheckoutPayCashReceiptApiResponse,
  PostCheckoutPayCashReceiptApiArgSchema,
  PostCorrectiveTaxDocumentForCreatingApiResponse,
  PostCorrectiveTaxDocumentForCreatingApiArg,
  PostCorrectiveTaxDocumentForCreatingApiArgSchema,
  PostCorrectiveTaxDocumentForCreatingApiResponseSchema,
  PostCorrectiveTaxDocumentIssueApiArg,
  PostCorrectiveTaxDocumentIssueApiResponse,
  PostCorrectiveTaxDocumentIssueApiResponseSchema,
  PostCorrectiveTaxDocumentIssueApiArgSchema,
  PostCheckoutForServiceOrderApiArg,
  PostCheckoutForServiceOrderApiArgSchema,
  PostCheckoutForServiceOrderApiResponse,
  PostCheckoutForServiceOrderApiResponseSchema,
  GetCheckoutPaymentTemplatesApiArg,
  GetCheckoutPaymentTemplatesApiResponse,
  GetCheckoutPaymentTemplatesApiResponseSchema,
  PostCheckoutPaymentCorrectionCreateApiResponseSchema,
  PostCheckoutPaymentCorrectionCancelApiResponseSchema,
  PostCheckoutPaymentFullCorrectionCreateApiArg,
  PostCheckoutPaymentCorrectionCreateApiResponse,
  PostCheckoutPaymentFullCorrectionCancelApiArg,
  PostCheckoutPaymentCorrectionCancelApiResponse,
  PostCheckoutPaymentCorrectionDiscardApiResponse,
  PostCheckoutPaymentCorrectionDiscardApiResponseSchema,
  PostCheckoutPaymentFullCorrectionDiscardApiArg,
  PostCheckoutPaymentPartialCorrectionDiscardApiArg,
  PostCheckoutPaymentFullCorrectionIssueApiArg,
  PostCheckoutPaymentFullCorrectionIssueApiResponse,
  PostCheckoutPaymentPartialCorrectionCreateApiArg,
  PostCheckoutPaymentPartialCorrectionCancelApiArg,
  PostCheckoutPaymentPartialCorrectionIssueApiArg,
  PostCheckoutPaymentPartialCorrectionIssueApiResponse,
  PostCheckoutPaymentInvoiceCancelApiArg,
  PostCheckoutPaymentInvoiceCancelApiResponseSchema,
  PostCheckoutPaymentInvoiceCancelApiResponse,
  PostCheckoutPaymentInvoiceIssueApiArg,
  PostCheckoutPaymentInvoiceIssueApiResponse,
} from './types';

const findBalancePaymentId = (payments: GetCheckoutPaymentsV2ApiResponse | undefined) =>
  payments?.find((payment) => payment.discriminator === 'BALANCE')?.checkoutPaymentId;

// The balance payment amount is recalculated on the server whenever a sibling
// payment of the checkout changes, so its detail cache must be invalidated too.
const invalidateBalancePaymentOnSuccess: TypedMutationOnQueryStarted<
  unknown,
  {checkoutId: string},
  typeof metadaBaseQuery,
  typeof metadaApi.reducerPath
> = async (queryArg, {dispatch, queryFulfilled, getState}) => {
  try {
    await queryFulfilled;
  } catch {
    return;
  }
  const {data: payments} = metadaAftersalesCheckoutApi.endpoints.getCheckoutPaymentsV2.select({
    checkoutId: queryArg.checkoutId,
  })(getState());
  const balancePaymentId = findBalancePaymentId(payments);
  if (isNotNil(balancePaymentId)) {
    dispatch(
      metadaAftersalesCheckoutApi.util.invalidateTags([
        {type: 'afsPaymentById', id: balancePaymentId},
      ])
    );
  }
};

export const metadaAftersalesCheckoutApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getCheckoutById: build.query<GetCheckoutByIdApiResponse, GetCheckoutByIdApiArg>({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetCheckoutByIdApiResponseSchema,
        requestSchema: CheckoutIdArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        'afsCheckout',
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    putCheckoutDepositPaymentAllow: build.mutation<
      PutCheckoutDepositPaymentAllowApiResponse,
      PutCheckoutDepositPaymentAllowApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/allow-deposit`,
        method: 'PUT',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PutCheckoutDepositPaymentAllowApiResponseSchema,
        requestSchema: PutCheckoutDepositPaymentAllowApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        'afsPaymentByIdList',
        'afsPaymentTemplates',
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.balancePaymentId ?? 'LIST'},
      ],
    }),
    postCheckoutForeignCurrencyPaymentAllow: build.mutation<
      PostCheckoutForeignCurrencyPaymentAllowApiResponse,
      PostCheckoutForeignCurrencyPaymentAllowApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/allow-foreign-currency-payment`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutForeignCurrencyPaymentAllowApiResponseSchema,
        requestSchema: PostCheckoutForeignCurrencyPaymentAllowApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        'afsPaymentByIdList',
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    getCheckoutBillingInformation: build.query<
      GetCheckoutBillingInformationApiResponse,
      GetCheckoutBillingInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/billing-information`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetCheckoutBillingInformationApiResponseSchema,
        requestSchema: CheckoutIdArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
      ],
    }),
    postCheckoutDepositPaymentCreate: build.mutation<
      PostCheckoutDepositPaymentCreateApiResponse,
      PostCheckoutDepositPaymentCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/deposit`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutDepositPaymentCreateApiResponseSchema,
        requestSchema: CheckoutIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        'afsPaymentByIdList',
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        'afsPaymentIssueRestriction',
      ],
    }),
    deleteCheckoutDepositPayment: build.mutation<
      DeleteCheckoutDepositPaymentApiResponse,
      DeleteCheckoutDepositPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/deposit/${queryArg.paymentId}`,
        method: 'DELETE',
        queryArg,
      }),
      extraOptions: {
        responseSchema: DeleteCheckoutDepositPaymentApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        'afsPaymentByIdList',
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        'afsPaymentIssueRestriction',
      ],
    }),
    putCheckoutDepositPaymentDisallow: build.mutation<
      PutCheckoutDepositPaymentDisallowApiResponse,
      PutCheckoutDepositPaymentDisallowApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/disallow-deposit`,
        method: 'PUT',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PutCheckoutDepositPaymentDisallowApiResponseSchema,
        requestSchema: PutCheckoutDepositPaymentDisallowApiArgSchema,
      },
      onQueryStarted: async (queryArg, {dispatch, queryFulfilled}) => {
        const patchResult = dispatch(
          metadaAftersalesCheckoutApi.util.updateQueryData(
            'getCheckoutById',
            {checkoutId: queryArg.checkoutId},
            (draft) => {
              if (isNotNil(draft)) {
                draft.isDepositAllowed = false;
              }
            }
          )
        );
        await queryFulfilled.catch(() => {
          patchResult.undo();
        });
      },
      invalidatesTags: (result, error, queryArg) => [
        'afsPaymentByIdList',
        'afsPaymentTemplates',
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.balancePaymentId ?? 'LIST'},
      ],
    }),
    patchCheckoutForeignCurrencyPaymentDisallow: build.mutation<
      PatchCheckoutForeignCurrencyPaymentDisallowApiResponse,
      PatchCheckoutForeignCurrencyPaymentDisallowApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/disallow-foreign-currency-payment`,
        method: 'PATCH',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PatchCheckoutForeignCurrencyPaymentDisallowApiResponseSchema,
        requestSchema: CheckoutIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        'afsPaymentByIdList',
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    getCheckoutPaymentById: build.query<
      GetCheckoutPaymentByIdApiResponse,
      GetCheckoutPaymentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetCheckoutPaymentByIdApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        'afsPaymentByIdList',
        'afsPaymentsList',
        'afsPaymentById',
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
      ],
    }),
    patchCheckoutPayment: build.mutation<
      PatchCheckoutPaymentApiResponse,
      PatchCheckoutPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PatchCheckoutPaymentApiResponseSchema,
        requestSchema: PatchCheckoutPaymentApiArgSchema,
      },
      onQueryStarted: invalidateBalancePaymentOnSuccess,
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
      ],
    }),
    postCheckoutRecordPaid: build.mutation<
      PostCheckoutRecordPaidApiResponse,
      PostCheckoutRecordPaidApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/record-paid`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutRecordPaidApiResponseSchema,
        requestSchema: PostCheckoutRecordPaidApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
        'directSales',
      ],
    }),
    getCheckoutPaymentsV2: build.query<
      GetCheckoutPaymentsV2ApiResponse,
      GetCheckoutPaymentsV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v2/checkout/${queryArg.checkoutId}/payments`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetCheckoutPaymentsV2ApiResponseSchema,
        requestSchema: CheckoutIdArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCorrectionDiscardPaymentsList', id: queryArg.checkoutId},
      ],
    }),
    putCheckoutSetBillingInformation: build.mutation<
      PutCheckoutSetBillingInformationApiResponse,
      PutCheckoutSetBillingInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/set-billing-information`,
        method: 'PUT',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PutCheckoutSetBillingInformationApiResponseSchema,
        requestSchema: PutCheckoutSetBillingInformationApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        // The backend recalculates payment due and dueDate from the new invoice recipient
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        'serviceOrders',
      ],
    }),
    putCheckoutSetContractInformation: build.mutation<
      PutCheckoutSetContractInformationApiResponse,
      PutCheckoutSetContractInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/set-contract-information`,
        method: 'PUT',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PutCheckoutSetContractInformationApiResponseSchema,
        requestSchema: PutCheckoutSetContractInformationApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    postCheckoutAdditionalCustomer: build.mutation<
      PostCheckoutAdditionalCustomerApiResponse,
      PostCheckoutAdditionalCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/additional-customer`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutAdditionalCustomerApiResponseSchema,
        requestSchema: PostCheckoutAdditionalCustomerApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    deleteCheckoutAdditionalCustomer: build.mutation<
      DeleteCheckoutAdditionalCustomerApiResponse,
      DeleteCheckoutAdditionalCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/additional-customer/${queryArg.additionalCustomerId}`,
        method: 'DELETE',
        queryArg,
      }),
      extraOptions: {
        responseSchema: DeleteCheckoutAdditionalCustomerApiResponseSchema,
        requestSchema: DeleteCheckoutAdditionalCustomerApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    getCheckoutAllowedCustomer: build.query<
      GetCheckoutAllowedCustomerApiResponse,
      GetCheckoutAllowedCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/allowed-customer`,
        queryArg,
      }),
      providesTags: ['afsAllowedCustomer'],
      extraOptions: {
        responseSchema: GetCheckoutAllowedCustomerApiResponseSchema,
        requestSchema: CheckoutIdArgSchema,
      },
    }),
    patchCheckoutAdditionalCustomer: build.mutation<
      PatchCheckoutAdditionalCustomerApiResponse,
      PatchCheckoutAdditionalCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/additional-customer/${queryArg.additionalCustomerId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PatchCheckoutAdditionalCustomerApiResponseSchema,
        requestSchema: PatchCheckoutAdditionalCustomerApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    getCheckoutLinkForServiceOrder: build.query<
      GetCheckoutLinkForServiceOrderApiResponse,
      GetCheckoutLinkForServiceOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/service-order/${queryArg.serviceOrderId}/checkout-link`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'checkoutLink', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetCheckoutLinkForServiceOrderApiResponseSchema,
        requestSchema: GetCheckoutLinkForServiceOrderApiArgSchema,
      },
    }),
    getCheckoutPaymentIssueRestriction: build.query<
      GetCheckoutPaymentIssueRestrictionApiResponse,
      GetCheckoutPaymentIssueRestrictionApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/issue-restriction`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetCheckoutPaymentIssueRestrictionApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        'afsPaymentIssueRestriction',
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
      ],
    }),
    putCheckoutSetTypeOfSale: build.mutation<
      PutCheckoutSetTypeOfSaleApiResponse,
      PutCheckoutSetTypeOfSaleApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/set-type-of-sale`,
        method: 'PUT',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PutCheckoutSetTypeOfSaleApiResponseSchema,
        requestSchema: PutCheckoutSetTypeOfSaleApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsCheckout', id: queryArg.checkoutId},
        'afsPaymentIssueRestriction',
        'afsPaymentById',
        'afsPaymentTemplates',
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
        'serviceOrderJobTotalAmount',
        'directSales',
      ],
    }),
    postAllowAbroadSale: build.mutation<
      PostCheckoutAllowAbroadSaleApiResponse,
      PostCheckoutAllowAbroadSaleApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/allow-abroad-sale`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutAllowAbroadSaleApiResponseSchema,
        requestSchema: PostCheckoutAllowAbroadSaleApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        'afsPaymentsList',
        'serviceOrder',
        'serviceCaseTotalAmount',
        'afsPaymentById',
        'directSales',
        'serviceOrders',
        queryArg.recordId ? {type: 'serviceOrderJobTotalAmount', id: queryArg.recordId} : undefined,
      ],
    }),
    postDisallowAbroadSale: build.mutation<
      PostCheckoutDisallowAbroadSaleApiResponse,
      PostCheckoutDisallowAbroadSaleApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/disallow-abroad-sale`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutDisallowAbroadSaleApiResponseSchema,
        requestSchema: PostCheckoutDisallowAbroadSaleApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsBillingInformation', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        'serviceOrder',
        'serviceCaseTotalAmount',
        'afsPaymentsList',
        'afsPaymentById',
        'directSales',
        'serviceOrders',
        queryArg.recordId ? {type: 'serviceOrderJobTotalAmount', id: queryArg.recordId} : undefined,
      ],
    }),
    getCheckoutPaymentTransactions: build.query<
      GetCheckoutPaymentTransactionsApiResponse,
      GetCheckoutPaymentTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/transactions`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetCheckoutPaymentTransactionsApiResponseSchema,
        requestSchema: GetCheckoutPaymentTransactionsApiArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
      ],
    }),
    postCheckoutPaymentTransactionCancel: build.mutation<
      PostCheckoutPaymentTransactionCancelApiResponse,
      PostCheckoutPaymentTransactionCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/transaction/${queryArg.transactionId}/cancel`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentTransactionCancelApiResponseSchema,
        requestSchema: PostCheckoutPaymentTransactionCancelApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
      ],
    }),
    postCheckoutPaymentTransactionIssueTaxDocument: build.mutation<
      PostCheckoutPaymentTransactionIssueTaxDocumentApiResponse,
      PostCheckoutPaymentTransactionIssueTaxDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/transaction/${queryArg.transactionId}/tax-document`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentTransactionIssueTaxDocumentApiResponseSchema,
        requestSchema: PostCheckoutPaymentTransactionIssueTaxDocumentApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
      ],
    }),
    postCheckoutPayBankTransfer: build.mutation<
      PostCheckoutPayBankTransferApiResponse,
      PostCheckoutPayBankTransferApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/pay-bank-transfer`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPayBankTransferApiResponseSchema,
        requestSchema: PostCheckoutPayBankTransferApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
        'directSales',
      ],
    }),
    postCheckoutPayCard: build.mutation<PostCheckoutPayCardApiResponse, PostCheckoutPayCardApiArg>({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/pay-card`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPayCardApiResponseSchema,
        requestSchema: PostCheckoutPayCardApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
        'directSales',
      ],
    }),
    postCheckoutPayCardReceipt: build.mutation<
      PostCheckoutPayCardReceiptApiResponse,
      PostCheckoutPayCardReceiptApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/pay-card-receipt`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPayCardReceiptApiResponseSchema,
        requestSchema: PostCheckoutPayCardReceiptApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
        'directSales',
      ],
    }),
    postCheckoutPayCash: build.mutation<PostCheckoutPayCashApiResponse, PostCheckoutPayCashApiArg>({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/pay-cash`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPayCashApiResponseSchema,
        requestSchema: PostCheckoutPayCashApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
        'directSales',
      ],
    }),
    postCheckoutPayCashReceipt: build.mutation<
      PostCheckoutPayCashReceiptApiResponse,
      PostCheckoutPayCashReceiptApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/pay-cash-receipt`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPayCashReceiptApiResponseSchema,
        requestSchema: PostCheckoutPayCashReceiptApiArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentIssueRestriction', id: 'LIST'},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentTransactions', id: queryArg.paymentId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
        'directSales',
      ],
    }),
    getCorrectiveTaxDocumentForCreating: build.query<
      PostCorrectiveTaxDocumentForCreatingApiResponse,
      PostCorrectiveTaxDocumentForCreatingApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/corrective-tax-document`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCorrectiveTaxDocumentForCreatingApiResponseSchema,
        requestSchema: PostCorrectiveTaxDocumentForCreatingApiArgSchema,
      },
    }),
    postCorrectiveTaxDocumentIssue: build.mutation<
      PostCorrectiveTaxDocumentIssueApiResponse,
      PostCorrectiveTaxDocumentIssueApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/corrective-tax-document/issue`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCorrectiveTaxDocumentIssueApiResponseSchema,
        requestSchema: PostCorrectiveTaxDocumentIssueApiArgSchema,
      },
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'profitabilityHistory',
        'serviceJobActions',
        'orderActions',
        'serviceJobActions',
        'serviceActions',
        'serviceCase',
        'serviceCaseTotalAmount',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJobs',
      ],
    }),
    postCheckoutForServiceOrder: build.mutation<
      PostCheckoutForServiceOrderApiResponse,
      PostCheckoutForServiceOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/service-order/${queryArg.serviceOrderId}/checkout`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutForServiceOrderApiResponseSchema,
        requestSchema: PostCheckoutForServiceOrderApiArgSchema,
      },
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PostCheckoutForServiceOrderApiArg) => [
          {type: 'checkoutLink', id: queryArg.serviceOrderId},
        ]
      ),
    }),
    getCheckoutPaymentTemplates: build.query<
      GetCheckoutPaymentTemplatesApiResponse,
      GetCheckoutPaymentTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/templates`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetCheckoutPaymentTemplatesApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        'afsPaymentTemplates',
        {type: 'afsPaymentTemplates', id: queryArg.paymentId},
      ],
    }),
    postCheckoutPaymentFullCorrectionCreate: build.mutation<
      PostCheckoutPaymentCorrectionCreateApiResponse,
      PostCheckoutPaymentFullCorrectionCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/full-correction`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentCorrectionCreateApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'serviceCase',
        'serviceOrders',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentFullCorrectionCancel: build.mutation<
      PostCheckoutPaymentCorrectionCancelApiResponse,
      PostCheckoutPaymentFullCorrectionCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/full-correction/cancel`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentCorrectionCancelApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'serviceOrders',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentFullCorrectionDiscard: build.mutation<
      PostCheckoutPaymentCorrectionDiscardApiResponse,
      PostCheckoutPaymentFullCorrectionDiscardApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/full-correction/discard`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentCorrectionDiscardApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      onQueryStarted: invalidateBalancePaymentOnSuccess,
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsCorrectionDiscardPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        'serviceCase',
        'serviceOrders',
        'orderActions',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentFullCorrectionIssue: build.mutation<
      PostCheckoutPaymentFullCorrectionIssueApiResponse,
      PostCheckoutPaymentFullCorrectionIssueApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/full-correction/issue`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentIssueApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'serviceCase',
        'serviceOrders',
        'orderActions',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentInvoiceCancel: build.mutation<
      PostCheckoutPaymentInvoiceCancelApiResponse,
      PostCheckoutPaymentInvoiceCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/invoice/cancel`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentInvoiceCancelApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      onQueryStarted: invalidateBalancePaymentOnSuccess,
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'serviceCase',
        'serviceOrders',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentInvoiceIssue: build.mutation<
      PostCheckoutPaymentInvoiceIssueApiResponse,
      PostCheckoutPaymentInvoiceIssueApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/invoice/issue`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentIssueApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      onQueryStarted: invalidateBalancePaymentOnSuccess,
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'serviceCase',
        'serviceOrders',
        'orderActions',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentPartialCorrectionCreate: build.mutation<
      PostCheckoutPaymentCorrectionCreateApiResponse,
      PostCheckoutPaymentPartialCorrectionCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/partial-correction`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentCorrectionCreateApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'serviceCase',
        'serviceOrders',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentPartialCorrectionCancel: build.mutation<
      PostCheckoutPaymentCorrectionCancelApiResponse,
      PostCheckoutPaymentPartialCorrectionCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/partial-correction/cancel`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentCorrectionCancelApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'serviceCase',
        'serviceOrders',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentPartialCorrectionDiscard: build.mutation<
      PostCheckoutPaymentCorrectionDiscardApiResponse,
      PostCheckoutPaymentPartialCorrectionDiscardApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/partial-correction/discard`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentCorrectionDiscardApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      onQueryStarted: invalidateBalancePaymentOnSuccess,
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsCorrectionDiscardPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        'serviceCase',
        'serviceOrders',
        'orderActions',
        'directSales',
        'headerDynamicActions',
      ],
    }),
    postCheckoutPaymentPartialCorrectionIssue: build.mutation<
      PostCheckoutPaymentPartialCorrectionIssueApiResponse,
      PostCheckoutPaymentPartialCorrectionIssueApiArg
    >({
      query: (queryArg) => ({
        url: `/checkout/v1/checkout/${queryArg.checkoutId}/payment/${queryArg.paymentId}/partial-correction/issue`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostCheckoutPaymentIssueApiResponseSchema,
        requestSchema: CheckoutIdPaymentIdArgSchema,
      },
      invalidatesTags: (result, error, queryArg) => [
        {type: 'afsPaymentById', id: queryArg.paymentId},
        {type: 'afsPaymentsList', id: queryArg.checkoutId},
        {type: 'afsCheckout', id: queryArg.checkoutId},
        {type: 'afsPaymentIssueRestriction', id: queryArg.paymentId},
        'orderActions',
        'serviceCase',
        'serviceOrders',
        'directSales',
        'headerDynamicActions',
      ],
    }),
  }),
});

export const {
  useGetCheckoutByIdQuery,
  usePutCheckoutDepositPaymentAllowMutation,
  usePostCheckoutForeignCurrencyPaymentAllowMutation,
  useGetCheckoutBillingInformationQuery,
  usePostCheckoutDepositPaymentCreateMutation,
  useDeleteCheckoutDepositPaymentMutation,
  usePutCheckoutDepositPaymentDisallowMutation,
  usePatchCheckoutForeignCurrencyPaymentDisallowMutation,
  useGetCheckoutPaymentByIdQuery,
  usePatchCheckoutPaymentMutation,
  usePostCheckoutRecordPaidMutation,
  useGetCheckoutPaymentsV2Query,
  usePutCheckoutSetBillingInformationMutation,
  usePutCheckoutSetContractInformationMutation,
  usePostCheckoutAdditionalCustomerMutation,
  useDeleteCheckoutAdditionalCustomerMutation,
  useGetCheckoutAllowedCustomerQuery,
  usePatchCheckoutAdditionalCustomerMutation,
  useGetCheckoutLinkForServiceOrderQuery,
  useGetCheckoutPaymentIssueRestrictionQuery,
  usePutCheckoutSetTypeOfSaleMutation,
  usePostAllowAbroadSaleMutation,
  usePostDisallowAbroadSaleMutation,
  useGetCheckoutPaymentTransactionsQuery,
  usePostCheckoutPaymentTransactionCancelMutation,
  usePostCheckoutPaymentTransactionIssueTaxDocumentMutation,
  usePostCheckoutPayBankTransferMutation,
  usePostCheckoutPayCardMutation,
  usePostCheckoutPayCardReceiptMutation,
  usePostCheckoutPayCashMutation,
  usePostCheckoutPayCashReceiptMutation,
  useGetCorrectiveTaxDocumentForCreatingQuery,
  usePostCorrectiveTaxDocumentIssueMutation,
  usePostCheckoutForServiceOrderMutation,
  useGetCheckoutPaymentTemplatesQuery,
  usePostCheckoutPaymentFullCorrectionCreateMutation,
  usePostCheckoutPaymentFullCorrectionCancelMutation,
  usePostCheckoutPaymentFullCorrectionDiscardMutation,
  usePostCheckoutPaymentFullCorrectionIssueMutation,
  usePostCheckoutPaymentInvoiceCancelMutation,
  usePostCheckoutPaymentInvoiceIssueMutation,
  usePostCheckoutPaymentPartialCorrectionCreateMutation,
  usePostCheckoutPaymentPartialCorrectionCancelMutation,
  usePostCheckoutPaymentPartialCorrectionDiscardMutation,
  usePostCheckoutPaymentPartialCorrectionIssueMutation,
} = metadaAftersalesCheckoutApi;
